import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RomanticPersonalizedReport from "./component";
import { getGuestUser, GetUserById } from "../settings/actions";
import {
  getInsightfulContent,
  sendToPartnerReportOnEmail,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getUserByIdConnect: GetUserById,
      sendToPartnerReportOnEmailConnect: sendToPartnerReportOnEmail,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
      getGuestUserConnect: getGuestUser,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RomanticPersonalizedReport);
